import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
  Upload: any;
};

export type ActiveDiscountByCodeInput = {
  code: Scalars['String'];
  machineId: Scalars['String'];
};

export type AddNewCampaignInput = {
  autoDiscount?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['ID']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
};

export type AddNewGeographicalLocationInput = {
  geographicalLocationName: Scalars['String'];
};

export type AddNewLocationCategoryInput = {
  locationCategoryName: Scalars['String'];
};

export type AddNewLocationTypeInput = {
  locationTypeName: Scalars['String'];
};

export type AddNewMachineLocationInput = {
  Canteen?: InputMaybe<Scalars['String']>;
  clothingType?: InputMaybe<Scalars['Int']>;
  corporatehq?: InputMaybe<Scalars['Boolean']>;
  customerType?: InputMaybe<Scalars['String']>;
  directCompetitor?: InputMaybe<Scalars['Int']>;
  geographicalLocationId?: InputMaybe<Scalars['String']>;
  homeOfficeDays?: InputMaybe<Scalars['Int']>;
  isLocalPopulation?: InputMaybe<Scalars['Boolean']>;
  locationCategoryId?: InputMaybe<Scalars['String']>;
  locationName: Scalars['String'];
  locationSize?: InputMaybe<Scalars['Int']>;
  locationTypeId?: InputMaybe<Scalars['String']>;
  machinePosition?: InputMaybe<Scalars['String']>;
  outdoorCompetition?: InputMaybe<Scalars['Int']>;
};

export type AddNewProductInput = {
  category: Category;
  collaborationItem?: InputMaybe<Scalars['Boolean']>;
  collaborationOrigin?: InputMaybe<Scalars['String']>;
  dishTemperature?: InputMaybe<DishTemperature>;
  images: Array<ImageInput>;
  labelIds: Array<Scalars['String']>;
  origin: ProductOrigin;
  price: Scalars['Int'];
  procurementPrice?: InputMaybe<Scalars['Int']>;
  shelfLife?: InputMaybe<Scalars['Int']>;
  stockLevelAlert: Scalars['Int'];
  texts: Array<TextInput>;
};

export type AddProductCapacityInput = {
  capacity: Scalars['Int'];
  machineId: Scalars['ID'];
  productId: Scalars['ID'];
};

export enum ApiTier {
  Internal = 'INTERNAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type BatchCreateDiscountsInput = {
  amount: Scalars['Int'];
  config: CreateDiscountInput;
};

export type Campaign = {
  __typename?: 'Campaign';
  autoDiscount?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['String'];
  description: Scalars['String'];
  discount?: Maybe<Discount>;
  discountId?: Maybe<Scalars['ID']>;
  discountType?: Maybe<Scalars['String']>;
  discountValue?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CampaignActivitiesInput = {
  campaignId: Scalars['ID'];
};

export type CampaignActivity = {
  __typename?: 'CampaignActivity';
  campaignId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']>;
  discountId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  machineId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  sendDate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CardCapture = {
  __typename?: 'CardCapture';
  id: Scalars['ID'];
  payment: Payment;
};

export type CardData = {
  __typename?: 'CardData';
  description?: Maybe<Scalars['String']>;
  fingerPrint?: Maybe<Scalars['String']>;
  retailTransactionID?: Maybe<Scalars['String']>;
  sessionID: Scalars['ID'];
  type: PaymentMethod;
};

export type CardTerminal = {
  __typename?: 'CardTerminal';
  id: Scalars['ID'];
  machine?: Maybe<Machine>;
  name: Scalars['String'];
};

export enum Category {
  Bowl = 'BOWL',
  Breakfast = 'BREAKFAST',
  Drink = 'DRINK',
  Pie = 'PIE',
  Snack = 'SNACK',
  Soup = 'SOUP',
  Warm = 'WARM',
  Wrap = 'WRAP'
}

export type ChangeStockQuantityByOneInput = {
  id: Scalars['ID'];
  isDecrease: Scalars['Boolean'];
  source: StockSnapshotSource;
};

export type ChannelInput = {
  channel: Scalars['Int'];
  machineId: Scalars['ID'];
};

export type ClearForecastInput = {
  tableName: Scalars['String'];
};

export enum ConfigKey {
  LockDay = 'LOCK_DAY',
  LockHour = 'LOCK_HOUR',
  StartOnMenu = 'START_ON_MENU',
  UnlockDate = 'UNLOCK_DATE',
  UnlockDay = 'UNLOCK_DAY',
  UnlockHour = 'UNLOCK_HOUR'
}

export type ConsentedCustomersInput = {
  Limit?: InputMaybe<Scalars['Int']>;
  LoyaltyOnly?: InputMaybe<Scalars['Boolean']>;
  Offset?: InputMaybe<Scalars['Int']>;
  OrderBy?: InputMaybe<Array<ListOrder>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CookingActual = {
  __typename?: 'CookingActual';
  cookedForDate: Scalars['String'];
  id: Scalars['ID'];
  numberCooked: Scalars['Int'];
  productId: Scalars['String'];
};

export type CookingActualInput = {
  cookedForDate: Scalars['String'];
  numberCooked?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
};

export type CopyMachineConfigInput = {
  copyChannels: Scalars['Boolean'];
  copyInventory: Scalars['Boolean'];
  copyMenuItems: Scalars['Boolean'];
  copyPaymentMethods: Scalars['Boolean'];
  location: Scalars['String'];
  machineId: Scalars['ID'];
};

export type CreateDatatransCustomerInput = {
  orderId: Scalars['ID'];
  token: Scalars['String'];
};

export type CreateDiscountInput = {
  active: Scalars['Boolean'];
  code?: InputMaybe<Scalars['String']>;
  reduction: Scalars['Int'];
  singleUse: Scalars['Boolean'];
  type: DiscountType;
  validFrom: Scalars['Date'];
  validMachineIds: Array<Scalars['String']>;
  validTo: Scalars['Date'];
};

export type CreateMenuItemInput = {
  availableFrom?: InputMaybe<Scalars['Date']>;
  availableTo?: InputMaybe<Scalars['Date']>;
  machineId: Scalars['ID'];
  overridePrice?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
};

export type CreateStockInput = {
  channel: Scalars['Int'];
  menuItemId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type CurrentStock = {
  __typename?: 'CurrentStock';
  balance?: Maybe<Scalars['Int']>;
  lastEventTime?: Maybe<Scalars['String']>;
};

export type Customer = {
  __typename?: 'Customer';
  consentEmail?: Maybe<Scalars['Boolean']>;
  consentEmailAt?: Maybe<Scalars['Date']>;
  consentPhone?: Maybe<Scalars['Boolean']>;
  consentPhoneAt?: Maybe<Scalars['Date']>;
  consentedToMarketingAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  fingerPrint?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  loyaltyPurchases?: Maybe<Scalars['Int']>;
  loyaltySignup?: Maybe<Scalars['Boolean']>;
  loyaltySignupAt?: Maybe<Scalars['Date']>;
  marketingConsent: Scalars['Boolean'];
  orders: Array<Order>;
  phoneNumber?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type DailyDishSales = {
  __typename?: 'DailyDishSales';
  Category?: Maybe<Scalars['String']>;
  Date?: Maybe<Scalars['String']>;
  Demand?: Maybe<Scalars['Int']>;
  Dish?: Maybe<Scalars['String']>;
  Machine?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type DatatransData = {
  __typename?: 'DatatransData';
  sessionID: Scalars['ID'];
  type: PaymentMethod;
};

export type DateInterval = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type Demand = {
  __typename?: 'Demand';
  Category?: Maybe<Scalars['String']>;
  Date?: Maybe<Scalars['String']>;
  Demand?: Maybe<Scalars['Int']>;
  Dish?: Maybe<Scalars['String']>;
  Machine?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type Discount = {
  __typename?: 'Discount';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  id: Scalars['ID'];
  orders: Array<Order>;
  reduction: Scalars['Int'];
  singleUse: Scalars['Boolean'];
  type: DiscountType;
  validFrom: Scalars['Date'];
  validMachineIds: Array<Scalars['String']>;
  validTo: Scalars['Date'];
};

export type DiscountByCodeLikeInput = {
  code: Scalars['String'];
};

export enum DiscountType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type DishSortOrderInput = {
  productId: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum DishTemperature {
  Cold = 'COLD',
  Either = 'EITHER',
  Hot = 'HOT'
}

export type Error = {
  __typename?: 'Error';
  date: Scalars['Date'];
  id: Scalars['ID'];
  machine: Machine;
  metadata?: Maybe<ErrorMetadata>;
  statusCode: Scalars['String'];
};

export type ErrorMetadata = {
  __typename?: 'ErrorMetadata';
  expectedInventory?: Maybe<Scalars['Int']>;
  requestedChannel?: Maybe<Scalars['Int']>;
};

export type ErrorMetadataInput = {
  expectedInventory?: InputMaybe<Scalars['Int']>;
  requestedChannel?: InputMaybe<Scalars['Int']>;
};

export type ForecastInput = {
  dishIds: Array<Scalars['String']>;
  model: Scalars['String'];
  start: Scalars['String'];
};

export type ForecastResult = {
  __typename?: 'ForecastResult';
  machineIds: Array<MachineInfo>;
  results: Array<StockingForecast>;
};

export type GeographicalLocation = {
  __typename?: 'GeographicalLocation';
  createdAt?: Maybe<Scalars['Date']>;
  geographicalLocationName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type GrossSalesPerMachineResult = {
  __typename?: 'GrossSalesPerMachineResult';
  grossSales: Scalars['Float'];
  machineId: Scalars['String'];
  machineLocation: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['ID'];
  imageType: ImageType;
  imageUrl: Scalars['String'];
  product: Product;
};

export type ImageInput = {
  imageType: ImageType;
  imageUrl: Scalars['String'];
};

export enum ImageType {
  Description = 'DESCRIPTION',
  Slide = 'SLIDE',
  Splash = 'SPLASH'
}

export type InitiateSwishPaymentInput = {
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};

export type InitiateSwishQrPaymentOutput = {
  __typename?: 'InitiateSwishQRPaymentOutput';
  payment: Payment;
  qrCode: Scalars['String'];
  token: Scalars['String'];
};

export type Label = {
  __typename?: 'Label';
  id: Scalars['ID'];
  labelType: LabelType;
  products: Array<Product>;
};

export enum LabelType {
  Cold = 'COLD',
  New = 'NEW',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
  Warm = 'WARM'
}

export type ListOrder = {
  Direction: Scalars['String'];
  FieldName: Scalars['String'];
};

export enum Locale {
  En = 'EN',
  Se = 'SE'
}

export type LocationCategory = {
  __typename?: 'LocationCategory';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  locationCategoryName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type LocationType = {
  __typename?: 'LocationType';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  locationTypeName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type LogErrorInput = {
  date: Scalars['Date'];
  machineId: Scalars['ID'];
  metadata?: InputMaybe<ErrorMetadataInput>;
  statusCode: Scalars['String'];
};

export type LogTemperatureInput = {
  machineId: Scalars['ID'];
  temperature: Scalars['String'];
};

export type LoyaltySignupInput = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type Machine = {
  __typename?: 'Machine';
  active: Scalars['Boolean'];
  cardTerminal?: Maybe<CardTerminal>;
  channels: Array<Scalars['Int']>;
  errors: Array<Error>;
  id: Scalars['ID'];
  isOpen?: Maybe<Scalars['Boolean']>;
  isfridge?: Maybe<Scalars['Int']>;
  lastPing?: Maybe<Scalars['Date']>;
  launchDate?: Maybe<Scalars['Date']>;
  location: Scalars['String'];
  machineConfigs: Array<MachineConfig>;
  machineLocationId?: Maybe<Scalars['ID']>;
  machineType?: Maybe<Scalars['String']>;
  menuItems: Array<MenuItem>;
  orders: Array<Order>;
  paymentMethods: Array<PaymentMethod>;
  pointOfServiceId?: Maybe<Scalars['ID']>;
  productCapacities: Array<ProductCapacity>;
  temperatures: Array<Temperature>;
  timezone: Scalars['String'];
  twentyfourHours?: Maybe<Scalars['Boolean']>;
};

export type MachineConfig = {
  __typename?: 'MachineConfig';
  id: Scalars['ID'];
  key: ConfigKey;
  machine: Machine;
  value: Scalars['String'];
};

export type MachineInfo = {
  __typename?: 'MachineInfo';
  machineId: Scalars['String'];
  machineLocation: Scalars['String'];
};

export type MachineLocation = {
  __typename?: 'MachineLocation';
  Canteen?: Maybe<Scalars['String']>;
  clothingType?: Maybe<Scalars['Int']>;
  corporatehq?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  customerType?: Maybe<Scalars['String']>;
  directCompetitor?: Maybe<Scalars['Int']>;
  geographicalLocation?: Maybe<GeographicalLocation>;
  geographicalLocationId?: Maybe<Scalars['String']>;
  homeOfficeDays?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isLocalPopulation?: Maybe<Scalars['Boolean']>;
  locationCategory?: Maybe<LocationCategory>;
  locationCategoryId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  locationSize?: Maybe<Scalars['Int']>;
  locationType?: Maybe<LocationType>;
  locationTypeId?: Maybe<Scalars['String']>;
  machinePosition?: Maybe<Scalars['String']>;
  outdoorCompetition?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  availableFrom?: Maybe<Scalars['Date']>;
  availableTo?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  launchDate?: Maybe<Scalars['Date']>;
  machine: Machine;
  overridePrice?: Maybe<Scalars['Int']>;
  product: Product;
  stocks: Array<Stock>;
};

export type MenuItemsByMachineIdInput = {
  includeUnavailable?: InputMaybe<Scalars['Boolean']>;
  machineId: Scalars['ID'];
};

export type MerchantData = CardData | DatatransData | SwishData;

export type Mutation = {
  __typename?: 'Mutation';
  activateProduct: Scalars['Boolean'];
  addChannel?: Maybe<Machine>;
  addNewCampaign: Campaign;
  addNewGeographicalLocation?: Maybe<GeographicalLocation>;
  addNewLocationCategory?: Maybe<LocationCategory>;
  addNewLocationType?: Maybe<LocationType>;
  addNewMachineLocation?: Maybe<MachineLocation>;
  addNewProduct: Product;
  addPaymentMethod?: Maybe<Machine>;
  addProductCapacity?: Maybe<ProductCapacity>;
  archiveMachineChannel: Scalars['String'];
  archiveStockRecords: Scalars['String'];
  batchCreateDiscounts: Array<Discount>;
  cancelCardPayment?: Maybe<Payment>;
  cancelSwishPayment: Payment;
  captureCardPayment: CardCapture;
  changeStockQuantityByOne: Stock;
  clearForecast: Scalars['Boolean'];
  copyMachineConfig?: Maybe<Machine>;
  createCookingActual: Scalars['Boolean'];
  createDatatransCustomer: Customer;
  createDiscount: Discount;
  createMenuItem: MenuItem;
  createStock: Stock;
  createStockTransactionV2?: Maybe<StockTransactionV2>;
  createUser?: Maybe<User>;
  deactivateProduct: Scalars['Boolean'];
  deletUserById?: Maybe<Scalars['Boolean']>;
  deleteChannel?: Maybe<Machine>;
  deleteMenuItem: MenuItem;
  deleteStock: Stock;
  deleteThisWeekMenuItem: Scalars['Boolean'];
  dummy?: Maybe<Scalars['String']>;
  exportForecast: Scalars['String'];
  initiateCardPayment: Payment;
  initiateDatatransPayment: Payment;
  initiateSwishPayment: Payment;
  initiateSwishQRPayment: InitiateSwishQrPaymentOutput;
  inventoryStockTransactionV2?: Maybe<StockTransactionV2>;
  logError: Error;
  logTemperature: Temperature;
  loyaltySignup: Customer;
  multiLog?: Maybe<MultiLog>;
  placeOrder: Order;
  platingCalculation: Scalars['Boolean'];
  refundAmount: Refund;
  refundCardPayment: Refund;
  refundSwishPayment: Refund;
  removeCustomerFromCampaign: Scalars['Int'];
  removeMachineConfig?: Maybe<Machine>;
  removePaymentMethod?: Maybe<Machine>;
  removeProductCapacity?: Maybe<Scalars['Boolean']>;
  runForecast: Scalars['Boolean'];
  runPulpCalculation: Scalars['Boolean'];
  saveCustomersToCampaign: Scalars['Int'];
  saveForecast: Scalars['Boolean'];
  saveForecastAdjustment: Scalars['Boolean'];
  saveMachineLockingConfig?: Maybe<Machine>;
  savePlatingCalculation: Scalars['Boolean'];
  saveThisWeekMenuItem: ThisWeekMenuItem;
  saveTotalPlated: Scalars['Boolean'];
  sendCampaign: Scalars['Int'];
  sendReceipt?: Maybe<Scalars['Boolean']>;
  sendWebsiteContactEmail: SendWebsiteContactEmailResponse;
  setActive?: Maybe<Machine>;
  setDishSortOrder: Scalars['Boolean'];
  setFridge?: Maybe<Machine>;
  setLocation?: Maybe<Machine>;
  setMachineCardTerminal?: Maybe<Machine>;
  setMachineConfig?: Maybe<Machine>;
  setMachineLocation?: Maybe<Machine>;
  setManyChannelStock?: Maybe<Array<Maybe<Array<Maybe<Scalars['Int']>>>>>;
  setPaymentStatus: Scalars['Boolean'];
  setStockQuantity: Stock;
  updateCampaign: Campaign;
  updateCustomer?: Maybe<Customer>;
  updateCustomerEmail: Scalars['Boolean'];
  updateCustomerMarketingConsentForOrder: Scalars['Boolean'];
  updateCustomerPhoneNumber: Scalars['Boolean'];
  updateDiscount: Discount;
  updateEverythingForOneChannel: Scalars['String'];
  updateGeographicalLocation?: Maybe<GeographicalLocation>;
  updateLocationCategory?: Maybe<LocationCategory>;
  updateLocationType?: Maybe<LocationType>;
  updateMachineData?: Maybe<Machine>;
  updateMachineLocation?: Maybe<MachineLocation>;
  updateMenuItem: MenuItem;
  updatePing?: Maybe<Machine>;
  updateProduct: Product;
  updateUser?: Maybe<User>;
  uploadForecast?: Maybe<Scalars['String']>;
  uploadPlatingCalculation?: Maybe<Scalars['String']>;
};


export type MutationActivateProductArgs = {
  id: Scalars['ID'];
};


export type MutationAddChannelArgs = {
  input: ChannelInput;
};


export type MutationAddNewCampaignArgs = {
  input: AddNewCampaignInput;
};


export type MutationAddNewGeographicalLocationArgs = {
  input: AddNewGeographicalLocationInput;
};


export type MutationAddNewLocationCategoryArgs = {
  input: AddNewLocationCategoryInput;
};


export type MutationAddNewLocationTypeArgs = {
  input: AddNewLocationTypeInput;
};


export type MutationAddNewMachineLocationArgs = {
  input: AddNewMachineLocationInput;
};


export type MutationAddNewProductArgs = {
  input: AddNewProductInput;
};


export type MutationAddPaymentMethodArgs = {
  input: PaymentMethodInput;
};


export type MutationAddProductCapacityArgs = {
  input: AddProductCapacityInput;
};


export type MutationArchiveMachineChannelArgs = {
  input: ArchiveMachineChannelInput;
};


export type MutationArchiveStockRecordsArgs = {
  input: ArchiveStockRecordsInput;
};


export type MutationBatchCreateDiscountsArgs = {
  input: BatchCreateDiscountsInput;
};


export type MutationCancelCardPaymentArgs = {
  paymentId: Scalars['ID'];
};


export type MutationCancelSwishPaymentArgs = {
  paymentId: Scalars['String'];
};


export type MutationCaptureCardPaymentArgs = {
  paymentId: Scalars['ID'];
};


export type MutationChangeStockQuantityByOneArgs = {
  input: ChangeStockQuantityByOneInput;
};


export type MutationClearForecastArgs = {
  input?: InputMaybe<ClearForecastInput>;
};


export type MutationCopyMachineConfigArgs = {
  input: CopyMachineConfigInput;
};


export type MutationCreateCookingActualArgs = {
  input: CookingActualInput;
};


export type MutationCreateDatatransCustomerArgs = {
  input: CreateDatatransCustomerInput;
};


export type MutationCreateDiscountArgs = {
  input: CreateDiscountInput;
};


export type MutationCreateMenuItemArgs = {
  input: CreateMenuItemInput;
};


export type MutationCreateStockArgs = {
  input: CreateStockInput;
};


export type MutationCreateStockTransactionV2Args = {
  input: StockTransactionV2Input;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeactivateProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeletUserByIdArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChannelArgs = {
  input: ChannelInput;
};


export type MutationDeleteMenuItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStockArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteThisWeekMenuItemArgs = {
  machineType: Scalars['String'];
  productId: Scalars['String'];
  weekFromDate: Scalars['String'];
};


export type MutationExportForecastArgs = {
  fromDate: Scalars['String'];
};


export type MutationInitiateCardPaymentArgs = {
  orderId: Scalars['ID'];
};


export type MutationInitiateDatatransPaymentArgs = {
  orderId: Scalars['ID'];
};


export type MutationInitiateSwishPaymentArgs = {
  input: InitiateSwishPaymentInput;
};


export type MutationInitiateSwishQrPaymentArgs = {
  orderId: Scalars['ID'];
};


export type MutationInventoryStockTransactionV2Args = {
  input: StockTransactionV2InventoryInput;
};


export type MutationLogErrorArgs = {
  input: LogErrorInput;
};


export type MutationLogTemperatureArgs = {
  input: LogTemperatureInput;
};


export type MutationLoyaltySignupArgs = {
  input: LoyaltySignupInput;
};


export type MutationMultiLogArgs = {
  apiToken?: InputMaybe<Scalars['String']>;
  clientToken?: InputMaybe<Scalars['String']>;
  gqlToken?: InputMaybe<Scalars['String']>;
  logLevel: Scalars['Int'];
  logPath?: InputMaybe<Scalars['String']>;
  logText?: InputMaybe<Scalars['String']>;
  machineId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationPlaceOrderArgs = {
  input: PlaceOrderInput;
};


export type MutationPlatingCalculationArgs = {
  date: Scalars['String'];
  useWaste?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRefundAmountArgs = {
  input: RefundAmountInput;
};


export type MutationRefundCardPaymentArgs = {
  input: RefundCardPaymentInput;
};


export type MutationRefundSwishPaymentArgs = {
  input: RefundSwishPaymentInput;
};


export type MutationRemoveCustomerFromCampaignArgs = {
  input: RemoveCustomerFromCampaignInput;
};


export type MutationRemoveMachineConfigArgs = {
  input: SetMachineConfigInput;
};


export type MutationRemovePaymentMethodArgs = {
  input: PaymentMethodInput;
};


export type MutationRemoveProductCapacityArgs = {
  input: RemoveProductCapacityInput;
};


export type MutationRunForecastArgs = {
  input: ForecastInput;
};


export type MutationRunPulpCalculationArgs = {
  date: Scalars['String'];
};


export type MutationSaveCustomersToCampaignArgs = {
  input: SaveCustomersToCampaignInput;
};


export type MutationSaveForecastArgs = {
  input: SaveForecastInput;
};


export type MutationSaveForecastAdjustmentArgs = {
  input: SaveForecastAdjustmentInput;
};


export type MutationSaveMachineLockingConfigArgs = {
  input: SaveMachineLockingConfigInput;
};


export type MutationSavePlatingCalculationArgs = {
  input: SavePlatingCalculationInput;
};


export type MutationSaveThisWeekMenuItemArgs = {
  input: ThisWeekMenuItemInput;
};


export type MutationSaveTotalPlatedArgs = {
  comment: Scalars['String'];
  commentCategory: Scalars['String'];
  machineId: Scalars['String'];
  numberPlated: Scalars['Int'];
  platingDate: Scalars['String'];
  platingDone?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['String'];
};


export type MutationSendCampaignArgs = {
  input: SendCampaignInput;
};


export type MutationSendReceiptArgs = {
  input: SendReceiptInput;
};


export type MutationSendWebsiteContactEmailArgs = {
  subject: Scalars['String'];
  text: Scalars['String'];
  to: Scalars['String'];
};


export type MutationSetActiveArgs = {
  input: SetActiveInput;
};


export type MutationSetDishSortOrderArgs = {
  orders: Array<DishSortOrderInput>;
  sortingDate: Scalars['String'];
};


export type MutationSetFridgeArgs = {
  input: SetFridgeInput;
};


export type MutationSetLocationArgs = {
  input: SetLocationInput;
};


export type MutationSetMachineCardTerminalArgs = {
  input: SetMachineCardTerminalInput;
};


export type MutationSetMachineConfigArgs = {
  input: SetMachineConfigInput;
};


export type MutationSetMachineLocationArgs = {
  input: SetMachineLocationInput;
};


export type MutationSetManyChannelStockArgs = {
  input: SetManyChannelStockInput;
};


export type MutationSetPaymentStatusArgs = {
  input: PaymentStatusInput;
};


export type MutationSetStockQuantityArgs = {
  input: SetStockQuantityInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerEmailArgs = {
  input: UpdateCustomerEmailInput;
};


export type MutationUpdateCustomerMarketingConsentForOrderArgs = {
  input: UpdateCustomerMarketingConsentForOrderInput;
};


export type MutationUpdateCustomerPhoneNumberArgs = {
  input: UpdateCustomerPhoneNumberInput;
};


export type MutationUpdateDiscountArgs = {
  input: UpdateDiscountInput;
};


export type MutationUpdateEverythingForOneChannelArgs = {
  input: UpdateEverythingLine;
};


export type MutationUpdateGeographicalLocationArgs = {
  input: UpdateGeographicalLocationInput;
};


export type MutationUpdateLocationCategoryArgs = {
  input: UpdateLocationCategoryInput;
};


export type MutationUpdateLocationTypeArgs = {
  input: UpdateLocationTypeInput;
};


export type MutationUpdateMachineDataArgs = {
  input: UpdateMachineDataInput;
};


export type MutationUpdateMachineLocationArgs = {
  input: UpdateMachineLocationInput;
};


export type MutationUpdateMenuItemArgs = {
  input: UpdateMenuItemInput;
};


export type MutationUpdatePingArgs = {
  input: UpdatePingInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUploadForecastArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadPlatingCalculationArgs = {
  file: Scalars['Upload'];
};

export type Order = {
  __typename?: 'Order';
  consentEmail?: Maybe<Scalars['Boolean']>;
  consentEmailAt?: Maybe<Scalars['Date']>;
  consentPhone?: Maybe<Scalars['Boolean']>;
  consentPhoneAt?: Maybe<Scalars['Date']>;
  customer?: Maybe<Customer>;
  discount?: Maybe<Discount>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  machine: Machine;
  orderDate: Scalars['Date'];
  orderItems: Array<OrderItem>;
  payment?: Maybe<Payment>;
  phoneNumber?: Maybe<Scalars['String']>;
  receiptSent: Scalars['Boolean'];
  status: OrderStatus;
  totalPrice: Scalars['Int'];
  totalReduction: Scalars['Float'];
};


export type OrderPaymentArgs = {
  nonPending?: InputMaybe<Scalars['Boolean']>;
};

export type OrderFilters = {
  customerId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<DateInterval>;
  machineId?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<Array<PaymentMethod>>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<OrderStatus>>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  channel?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  price: Scalars['Int'];
  product: Product;
  quantity: Scalars['Int'];
  stockId?: Maybe<Scalars['ID']>;
};

export type OrderItemsInput = {
  channel?: InputMaybe<Scalars['Int']>;
  price: Scalars['Int'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  stockId?: InputMaybe<Scalars['ID']>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  New = 'NEW',
  Paid = 'PAID'
}

export type Payment = {
  __typename?: 'Payment';
  cardCaptures: Array<CardCapture>;
  id: Scalars['ID'];
  merchantData: MerchantData;
  method: PaymentMethod;
  order: Order;
  refunds: Array<Refund>;
  status: PaymentStatus;
  totalAmount: Scalars['Float'];
};

export type PaymentFilter = {
  method?: InputMaybe<PaymentMethod>;
};

export enum PaymentMethod {
  Card = 'CARD',
  Datatrans = 'DATATRANS',
  Swish = 'SWISH'
}

export type PaymentMethodInput = {
  machineId: Scalars['ID'];
  method: PaymentMethod;
};

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Error = 'ERROR',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type PaymentStatusInput = {
  paymentId: Scalars['ID'];
  status: PaymentStatus;
};

export type PlaceOrderInput = {
  consentEmail?: InputMaybe<Scalars['Boolean']>;
  consentEmailAt?: InputMaybe<Scalars['Date']>;
  consentPhone?: InputMaybe<Scalars['Boolean']>;
  consentPhoneAt?: InputMaybe<Scalars['Date']>;
  discountId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  machineId: Scalars['ID'];
  orderItems: Array<OrderItemsInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type PlatingCalculation = {
  __typename?: 'PlatingCalculation';
  adjustedBalance: Scalars['Int'];
  calculatedForDate: Scalars['String'];
  category: Scalars['String'];
  dateOfCalculation: Scalars['String'];
  dish: Scalars['String'];
  lastEventTime?: Maybe<Scalars['String']>;
  machine: Scalars['String'];
  machineId: Scalars['String'];
  maxInMachine: Scalars['Int'];
  platedQuantity: Scalars['Int'];
  productId: Scalars['String'];
  productionForecasted?: Maybe<Scalars['Int']>;
  stockAfterRefill?: Maybe<Scalars['Int']>;
  stockStatus?: Maybe<Scalars['String']>;
  toBePlated: Scalars['Int'];
  waste?: Maybe<Scalars['Int']>;
};

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean'];
  capacity: Scalars['Int'];
  category: Category;
  collaborationItem?: Maybe<Scalars['Boolean']>;
  collaborationOrigin?: Maybe<Scalars['String']>;
  dishTemperature?: Maybe<DishTemperature>;
  durability: Scalars['Int'];
  id: Scalars['ID'];
  images: Array<Image>;
  labels: Array<Label>;
  menuItems: Array<MenuItem>;
  orderItems: Array<OrderItem>;
  origin: ProductOrigin;
  price: Scalars['Int'];
  procurementPrice?: Maybe<Scalars['Int']>;
  shelfLife?: Maybe<Scalars['Int']>;
  stockLevelAlert: Scalars['Int'];
  texts: Array<ProductText>;
};

export type ProductCapacity = {
  __typename?: 'ProductCapacity';
  capacity: Scalars['Int'];
  id: Scalars['Int'];
  machine: Machine;
  product?: Maybe<Product>;
  productId: Scalars['ID'];
};

export type ProductForPlatingCalculation = {
  __typename?: 'ProductForPlatingCalculation';
  category?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
};

export enum ProductOrigin {
  Colab = 'COLAB',
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type ProductText = {
  __typename?: 'ProductText';
  allergens?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  locale: Locale;
  name?: Maybe<Scalars['String']>;
  nutritionalInformation?: Maybe<Scalars['String']>;
  product: Product;
};

export type Query = {
  __typename?: 'Query';
  activeDiscountByCode?: Maybe<Discount>;
  calculateWaste: WasteCalculationResult;
  campaignActivitiesByCampaign: Array<CampaignActivity>;
  campaigns: Array<Campaign>;
  cardTerminals: Array<CardTerminal>;
  consentedCustomers: Array<Customer>;
  consentedCustomersCount?: Maybe<Scalars['Int']>;
  cookingActuals: Array<CookingActual>;
  currentStock?: Maybe<CurrentStock>;
  customers: Array<Customer>;
  demandByDishAndMachine: Array<Demand>;
  discountByCodeLike?: Maybe<Discount>;
  discountById: Discount;
  discounts: Array<Discount>;
  dummy?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  filteredOrders: Array<Order>;
  findCustomerByToken?: Maybe<Customer>;
  geographicalLocationById: GeographicalLocation;
  geographicalLocations: Array<GeographicalLocation>;
  getAllUsers?: Maybe<Array<User>>;
  getDailyDishSales: Array<DailyDishSales>;
  getForecast: ForecastResult;
  getMenuItemByMachineChannel?: Maybe<MenuItem>;
  getMenuItemByMachineProduct?: Maybe<Scalars['ID']>;
  getPlatingCalculation: Array<PlatingCalculation>;
  getPlatingCalculationNew: ForecastResult;
  getProductIdFromStock?: Maybe<Scalars['ID']>;
  getReceiptEmailForPaymentId?: Maybe<Scalars['String']>;
  getRequestedRefillPerMachine: Array<RequestedRefill>;
  getStockIdFromMachineChannel?: Maybe<Scalars['ID']>;
  getStockTransactionV2ById: StockTransactionV2;
  getUserById?: Maybe<User>;
  getUserByUserName?: Maybe<User>;
  getWebSiteMenuItems: Array<WebSiteMenuItem>;
  grossSalesPerMachine: Array<GrossSalesPerMachineResult>;
  hasMachineHadRefillToday: Scalars['Boolean'];
  isCustomerOptedIntoMarketing: Scalars['Boolean'];
  labels: Array<Label>;
  locationCategories: Array<LocationCategory>;
  locationCategoryById: LocationCategory;
  locationTypeById: LocationType;
  locationTypes: Array<LocationType>;
  machineById: Machine;
  machineLocationById: MachineLocation;
  machineLocations: Array<MachineLocation>;
  machines: Array<Machine>;
  menuItemById?: Maybe<MenuItem>;
  menuItems: Array<MenuItem>;
  menuItemsByMachineId: Array<MenuItem>;
  multiLogInit?: Maybe<MultiLog>;
  multiLogUpdate?: Maybe<MultiLog>;
  numberOfPaidOrders: Scalars['Int'];
  orderById: Order;
  ordersByInterval: Array<Order>;
  paymentById: Payment;
  payments: Array<Payment>;
  productById: Product;
  products: Array<Product>;
  productsForPlatingCalculation: Array<ProductForPlatingCalculation>;
  stockAfterRefill?: Maybe<StockAfterRefill>;
  stockItems: Array<Stock>;
  stockItemsByMachineId: Array<Stock>;
  stockTransactionV2machineInventory: StockTransactionV2machineInventory;
  thisWeekMenu: Array<ThisWeekMenu>;
  thisWeekMenuDishes: Array<ThisWeekMenuDish>;
  todaysGross: Scalars['Float'];
  todaysNet: Scalars['Float'];
};


export type QueryActiveDiscountByCodeArgs = {
  input: ActiveDiscountByCodeInput;
};


export type QueryCalculateWasteArgs = {
  calculatedForDate: Scalars['String'];
  machineId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryCampaignActivitiesByCampaignArgs = {
  input: CampaignActivitiesInput;
};


export type QueryConsentedCustomersArgs = {
  input?: InputMaybe<ConsentedCustomersInput>;
};


export type QueryConsentedCustomersCountArgs = {
  input?: InputMaybe<ConsentedCustomersInput>;
};


export type QueryCookingActualsArgs = {
  cookedForDate: Scalars['String'];
};


export type QueryCurrentStockArgs = {
  eventTime: Scalars['String'];
  machineId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryDemandByDishAndMachineArgs = {
  dishId: Scalars['String'];
  machineId: Scalars['String'];
};


export type QueryDiscountByCodeLikeArgs = {
  input: DiscountByCodeLikeInput;
};


export type QueryDiscountByIdArgs = {
  id: Scalars['ID'];
};


export type QueryDiscountsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFilteredOrdersArgs = {
  filters?: InputMaybe<OrderFilters>;
};


export type QueryFindCustomerByTokenArgs = {
  token: Scalars['String'];
};


export type QueryGeographicalLocationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetAllUsersArgs = {
  userType?: InputMaybe<UserType>;
};


export type QueryGetDailyDishSalesArgs = {
  dishId: Scalars['String'];
  machineId: Scalars['String'];
};


export type QueryGetForecastArgs = {
  endDate: Scalars['String'];
  forPlating?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
  useSortOrder?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetMenuItemByMachineChannelArgs = {
  input: MenuIdByMachineChannel;
};


export type QueryGetMenuItemByMachineProductArgs = {
  input: MenuIdByMachineProduct;
};


export type QueryGetPlatingCalculationArgs = {
  date: Scalars['String'];
};


export type QueryGetPlatingCalculationNewArgs = {
  endDate: Scalars['String'];
  forPlating?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
  useSortOrder?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetProductIdFromStockArgs = {
  stockId: Scalars['ID'];
};


export type QueryGetReceiptEmailForPaymentIdArgs = {
  paymentId: Scalars['ID'];
};


export type QueryGetRequestedRefillPerMachineArgs = {
  machineId: Scalars['String'];
  refillDate: Scalars['String'];
};


export type QueryGetStockIdFromMachineChannelArgs = {
  input: StockIdFromMachineChannel;
};


export type QueryGetStockTransactionV2ByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserByUserNameArgs = {
  userName: Scalars['String'];
};


export type QueryGrossSalesPerMachineArgs = {
  date: Scalars['String'];
};


export type QueryHasMachineHadRefillTodayArgs = {
  machineId: Scalars['ID'];
};


export type QueryIsCustomerOptedIntoMarketingArgs = {
  orderId?: InputMaybe<Scalars['ID']>;
};


export type QueryLocationCategoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryLocationTypeByIdArgs = {
  id: Scalars['ID'];
};


export type QueryMachineByIdArgs = {
  id: Scalars['ID'];
};


export type QueryMachineLocationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryMachinesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMenuItemByIdArgs = {
  menuItemId: Scalars['ID'];
};


export type QueryMenuItemsByMachineIdArgs = {
  input: MenuItemsByMachineIdInput;
};


export type QueryMultiLogInitArgs = {
  apiToken?: InputMaybe<Scalars['String']>;
  clientToken?: InputMaybe<Scalars['String']>;
  gqlToken?: InputMaybe<Scalars['String']>;
  logLevel?: InputMaybe<Scalars['Int']>;
  logPath?: InputMaybe<Scalars['String']>;
  logText?: InputMaybe<Scalars['String']>;
  machineId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryMultiLogUpdateArgs = {
  apiToken?: InputMaybe<Scalars['String']>;
  clientToken?: InputMaybe<Scalars['String']>;
  gqlToken?: InputMaybe<Scalars['String']>;
  logLevel?: InputMaybe<Scalars['Int']>;
  logPath?: InputMaybe<Scalars['String']>;
  logText?: InputMaybe<Scalars['String']>;
  machineId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryNumberOfPaidOrdersArgs = {
  machineId?: InputMaybe<Scalars['ID']>;
  sinceDate?: InputMaybe<Scalars['Date']>;
};


export type QueryOrderByIdArgs = {
  id: Scalars['ID'];
};


export type QueryOrdersByIntervalArgs = {
  interval: DateInterval;
};


export type QueryPaymentByIdArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentsArgs = {
  input?: InputMaybe<PaymentFilter>;
};


export type QueryProductByIdArgs = {
  id: Scalars['ID'];
};


export type QueryProductsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductsForPlatingCalculationArgs = {
  date: Scalars['String'];
};


export type QueryStockAfterRefillArgs = {
  eventTime: Scalars['String'];
  machineId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryStockItemsByMachineIdArgs = {
  machineId: Scalars['ID'];
};


export type QueryStockTransactionV2machineInventoryArgs = {
  machineId: Scalars['ID'];
};


export type QueryThisWeekMenuArgs = {
  machineType?: InputMaybe<Scalars['String']>;
  weekFromDate?: InputMaybe<Scalars['String']>;
};


export type QueryThisWeekMenuDishesArgs = {
  weekFromDate: Scalars['String'];
};


export type QueryTodaysGrossArgs = {
  machineId?: InputMaybe<Scalars['ID']>;
};


export type QueryTodaysNetArgs = {
  machineId?: InputMaybe<Scalars['ID']>;
};

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  merchantData?: Maybe<RefundMerchantData>;
  payment: Payment;
};

export type RefundAmountInput = {
  amount: Scalars['Float'];
  paymentId: Scalars['ID'];
};

export type RefundCardPaymentInput = {
  menuItemIdsToRefund: Array<Scalars['ID']>;
  paymentId: Scalars['ID'];
};

export type RefundMerchantData = {
  __typename?: 'RefundMerchantData';
  datePaid?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<SwishError>>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  paymentReference?: Maybe<Scalars['String']>;
  status?: Maybe<SwishRefundStatus>;
};

export type RefundSwishPaymentInput = {
  menuItemIdsToRefund: Array<Scalars['ID']>;
  paymentId: Scalars['ID'];
};

export type RemoveCustomerFromCampaignInput = {
  campaignId: Scalars['ID'];
  customerId: Scalars['ID'];
};

export type RemoveProductCapacityInput = {
  machineId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type RequestedRefill = {
  __typename?: 'RequestedRefill';
  machineId: Scalars['String'];
  numberToRefill: Scalars['Int'];
  productId: Scalars['String'];
  refillDate: Scalars['String'];
};

export type SaveCustomersToCampaignInput = {
  campaignId: Scalars['ID'];
  customers: Array<Scalars['String']>;
};

export type SaveForecastAdjustmentInput = {
  adjustedDemand: Scalars['Int'];
  datePredictedFor: Scalars['String'];
  machineId: Scalars['String'];
  productId: Scalars['String'];
};

export type SaveForecastInput = {
  category?: InputMaybe<Scalars['String']>;
  closed?: InputMaybe<Scalars['String']>;
  dateOfPrediction?: InputMaybe<Scalars['String']>;
  dates: Scalars['String'];
  dishId: Scalars['String'];
  machineId: Scalars['String'];
  machineName?: InputMaybe<Scalars['String']>;
  modelType: Scalars['String'];
  predictions: Scalars['String'];
  previousDates: Scalars['String'];
  previousObservations: Scalars['String'];
  productName?: InputMaybe<Scalars['String']>;
  rmseVal?: InputMaybe<Scalars['Float']>;
  tableName: Scalars['String'];
};

export type SaveMachineLockingConfigInput = {
  lockDay: Scalars['Int'];
  lockHour: Scalars['Int'];
  machineId: Scalars['ID'];
  unlockDay: Scalars['Int'];
  unlockHour: Scalars['Int'];
};

export type SavePlatingCalculationInput = {
  adjustedBalance: Scalars['Int'];
  calculatedForDate: Scalars['String'];
  category: Scalars['String'];
  dateOfCalculation: Scalars['String'];
  dish: Scalars['String'];
  lastEventTime?: InputMaybe<Scalars['String']>;
  machine: Scalars['String'];
  machineId: Scalars['String'];
  maxInMachine: Scalars['Int'];
  platedQuantity: Scalars['Int'];
  productId: Scalars['String'];
  productionForecasted?: InputMaybe<Scalars['Int']>;
  stockAfterRefill?: InputMaybe<Scalars['Int']>;
  stockStatus?: InputMaybe<Scalars['String']>;
  toBePlated: Scalars['Int'];
  waste?: InputMaybe<Scalars['Int']>;
};

export type SendCampaignInput = {
  campaignId: Scalars['ID'];
  campaignText: Scalars['String'];
  phoneNumbers: Array<Scalars['String']>;
};

export type SendReceiptInput = {
  email: Scalars['String'];
  paymentId: Scalars['String'];
  saveEmail?: InputMaybe<Scalars['Boolean']>;
};

export type SendWebsiteContactEmailResponse = {
  __typename?: 'SendWebsiteContactEmailResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SetActiveInput = {
  active: Scalars['Boolean'];
  machineId: Scalars['ID'];
};

export type SetFridgeInput = {
  isfridge: Scalars['Int'];
  machineId: Scalars['ID'];
};

export type SetLocationInput = {
  location: Scalars['String'];
  machineId: Scalars['ID'];
};

export type SetMachineCardTerminalInput = {
  machineId: Scalars['ID'];
  pointOfServiceId?: InputMaybe<Scalars['ID']>;
};

export type SetMachineConfigInput = {
  key: ConfigKey;
  machineId: Scalars['ID'];
  value: Scalars['String'];
};

export type SetMachineLocationInput = {
  machineId: Scalars['ID'];
  machineLocationId: Scalars['ID'];
};

export type SetManyChannelStockInput = {
  isRefill: Scalars['Boolean'];
  machineId: Scalars['ID'];
  stocks: Array<UpdateStockInput>;
};

export type SetStockQuantityInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type Stock = {
  __typename?: 'Stock';
  channel: Scalars['Int'];
  id: Scalars['ID'];
  menuItem: MenuItem;
  quantity: Scalars['Int'];
  snapshots: Array<StockSnapshot>;
};

export type StockAfterRefill = {
  __typename?: 'StockAfterRefill';
  Sales?: Maybe<Scalars['Float']>;
  intendedRefillDate?: Maybe<Scalars['String']>;
  machineId: Scalars['String'];
  productId: Scalars['String'];
  salesBeforeRefill?: Maybe<Scalars['Float']>;
};

export type StockSnapshot = {
  __typename?: 'StockSnapshot';
  channel: Scalars['Int'];
  id: Scalars['ID'];
  menuItemId: Scalars['ID'];
  quantity: Scalars['Int'];
  source: StockSnapshotSource;
  stock: Stock;
};

export enum StockSnapshotSource {
  Adjustment = 'ADJUSTMENT',
  Refill = 'REFILL',
  Sale = 'SALE',
  Unknown = 'UNKNOWN'
}

export type StockTransactionV2Input = {
  archived?: InputMaybe<Scalars['Int']>;
  channel: Scalars['Int'];
  machineId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  ref?: InputMaybe<Scalars['String']>;
  transactionTimestamp?: InputMaybe<Scalars['DateTime']>;
  transactionType: TransactionType;
  who?: InputMaybe<Scalars['ID']>;
};

export type StockTransactionV2InventoryInput = {
  balance: Scalars['Int'];
  channel: Scalars['Int'];
  machineId: Scalars['ID'];
  productId: Scalars['ID'];
  ref?: InputMaybe<Scalars['String']>;
  transactionTimestamp?: InputMaybe<Scalars['DateTime']>;
  who?: InputMaybe<Scalars['ID']>;
};

export type StockTransactionsFilterV2 = {
  channels?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<DateInterval>;
  machineId?: InputMaybe<Scalars['ID']>;
  transactionType?: InputMaybe<Array<TransactionType>>;
};

export type StockingForecast = {
  __typename?: 'StockingForecast';
  adjustedDemand?: Maybe<Scalars['Int']>;
  dateOfPrediction?: Maybe<Scalars['String']>;
  datePredictedFor?: Maybe<Scalars['String']>;
  demand?: Maybe<Scalars['Int']>;
  isFridge?: Maybe<Scalars['Boolean']>;
  machineId?: Maybe<Scalars['String']>;
  machineLocation?: Maybe<Scalars['String']>;
  machineType?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  platedQuantity?: Maybe<Scalars['Int']>;
  platingDone?: Maybe<Scalars['Boolean']>;
  productCategory?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

export type SwishData = {
  __typename?: 'SwishData';
  error?: Maybe<SwishError>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  payerAlias?: Maybe<Scalars['String']>;
  paymentReference?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type: PaymentMethod;
};

export type SwishError = {
  __typename?: 'SwishError';
  additionalInformation?: Maybe<Scalars['String']>;
  errorCode: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
};

export enum SwishRefundStatus {
  Debited = 'DEBITED',
  Error = 'ERROR',
  Paid = 'PAID',
  Validated = 'VALIDATED'
}

export type Temperature = {
  __typename?: 'Temperature';
  id: Scalars['ID'];
  machine: Machine;
  temperature: Scalars['Float'];
  time: Scalars['Date'];
};

export type TextInput = {
  allergens: Scalars['String'];
  description: Scalars['String'];
  instructions?: InputMaybe<Scalars['String']>;
  locale: Locale;
  name: Scalars['String'];
  nutritionalInformation?: InputMaybe<Scalars['String']>;
};

export type ThisWeekMenu = {
  __typename?: 'ThisWeekMenu';
  date: Scalars['String'];
  dishes: Array<ThisWeekMenuDish>;
  machineType: Scalars['String'];
  weekFromDate: Scalars['String'];
};

export type ThisWeekMenuDish = {
  __typename?: 'ThisWeekMenuDish';
  category: Scalars['String'];
  dish: Scalars['String'];
  productName?: Maybe<Scalars['String']>;
  weekFromDate: Scalars['String'];
};

export type ThisWeekMenuItem = {
  __typename?: 'ThisWeekMenuItem';
  date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  machineType?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  weekFromDate?: Maybe<Scalars['String']>;
};

export type ThisWeekMenuItemInput = {
  date: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  machineType: Scalars['String'];
  productId: Scalars['String'];
  weekFromDate: Scalars['String'];
};

export type UpdateCampaignInput = {
  autoDiscount?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['ID']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateCustomerEmailInput = {
  customerId: Scalars['ID'];
  email: Scalars['String'];
};

export type UpdateCustomerInput = {
  consentEmail?: InputMaybe<Scalars['Boolean']>;
  consentEmailAt?: InputMaybe<Scalars['Date']>;
  consentPhone?: InputMaybe<Scalars['Boolean']>;
  consentPhoneAt?: InputMaybe<Scalars['Date']>;
  consentedToMarketingAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  fingerPrint?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  loyaltyPurchases?: InputMaybe<Scalars['Int']>;
  loyaltySignup?: InputMaybe<Scalars['Boolean']>;
  loyaltySignupAt?: InputMaybe<Scalars['Date']>;
  marketingConsent: Scalars['Boolean'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerMarketingConsentForOrderInput = {
  marketingConsent: Scalars['Boolean'];
  orderId: Scalars['ID'];
};

export type UpdateCustomerPhoneNumberInput = {
  customerId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};

export type UpdateDiscountInput = {
  active: Scalars['Boolean'];
  code: Scalars['String'];
  id: Scalars['ID'];
  reduction: Scalars['Int'];
  singleUse: Scalars['Boolean'];
  type: DiscountType;
  validFrom: Scalars['Date'];
  validMachineIds: Array<Scalars['String']>;
  validTo: Scalars['Date'];
};

export type UpdateGeographicalLocationInput = {
  geographicalLocationId: Scalars['ID'];
  geographicalLocationName: Scalars['String'];
};

export type UpdateLocationCategoryInput = {
  locationCategoryId: Scalars['ID'];
  locationCategoryName: Scalars['String'];
};

export type UpdateLocationTypeInput = {
  locationTypeId: Scalars['ID'];
  locationTypeName: Scalars['String'];
};

export type UpdateMachineDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  isfridge?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  machineId: Scalars['ID'];
  machineType?: InputMaybe<Scalars['String']>;
  twentyfourHours?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMachineLocationInput = {
  Canteen?: InputMaybe<Scalars['String']>;
  clothingType?: InputMaybe<Scalars['Int']>;
  corporatehq?: InputMaybe<Scalars['Boolean']>;
  customerType?: InputMaybe<Scalars['String']>;
  directCompetitor?: InputMaybe<Scalars['Int']>;
  geographicalLocationId?: InputMaybe<Scalars['String']>;
  homeOfficeDays?: InputMaybe<Scalars['Int']>;
  isLocalPopulation?: InputMaybe<Scalars['Boolean']>;
  locationCategoryId?: InputMaybe<Scalars['String']>;
  locationName: Scalars['String'];
  locationSize?: InputMaybe<Scalars['Int']>;
  locationTypeId?: InputMaybe<Scalars['String']>;
  machineLocationId: Scalars['ID'];
  machinePosition?: InputMaybe<Scalars['String']>;
  outdoorCompetition?: InputMaybe<Scalars['Int']>;
};

export type UpdateMenuItemInput = {
  availableFrom?: InputMaybe<Scalars['Date']>;
  availableTo?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  overridePrice?: InputMaybe<Scalars['Int']>;
};

export type UpdatePingInput = {
  isOpen: Scalars['Boolean'];
  machineId: Scalars['ID'];
  newFlag?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProductInput = {
  category: Category;
  collaborationItem: Scalars['Boolean'];
  collaborationOrigin: Scalars['String'];
  dishTemperature: DishTemperature;
  images: Array<ImageInput>;
  labelIds: Array<Scalars['String']>;
  origin: ProductOrigin;
  price: Scalars['Int'];
  procurementPrice?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
  shelfLife?: InputMaybe<Scalars['Int']>;
  stockLevelAlert: Scalars['Int'];
  texts: Array<TextInput>;
};

export type UpdateStockInput = {
  channel?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  menuItemId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type WasteCalculationBucket = {
  __typename?: 'WasteCalculationBucket';
  date: Scalars['String'];
  leftToWaste: Scalars['Int'];
};

export type WasteCalculationLog = {
  __typename?: 'WasteCalculationLog';
  action: Scalars['String'];
  after?: Maybe<Scalars['Int']>;
  allocations?: Maybe<Array<WasteCalculationLogAllocation>>;
  before?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  timestampIso: Scalars['String'];
  transactionType: Scalars['String'];
  unmatchedOutflow?: Maybe<Scalars['Int']>;
};

export type WasteCalculationLogAllocation = {
  __typename?: 'WasteCalculationLogAllocation';
  after: Scalars['Int'];
  before: Scalars['Int'];
  date: Scalars['String'];
  used: Scalars['Int'];
};

export type WasteCalculationMeta = {
  __typename?: 'WasteCalculationMeta';
  calculatedDateIso: Scalars['String'];
  dateCalculatedFor: Scalars['String'];
  effectiveStart: Scalars['String'];
  firstTransaction?: Maybe<Scalars['String']>;
  lastTransaction?: Maybe<Scalars['String']>;
  machineId: Scalars['String'];
  productId: Scalars['String'];
  shelfLife: Scalars['Int'];
  transactionCount: Scalars['Int'];
  wasteForCalculatedDate: Scalars['Int'];
  wasteSourceDate?: Maybe<Scalars['String']>;
};

export type WasteCalculationResult = {
  __typename?: 'WasteCalculationResult';
  buckets: Array<WasteCalculationBucket>;
  log: Array<WasteCalculationLog>;
  meta: WasteCalculationMeta;
};

export type WebSiteMenuItem = {
  __typename?: 'WebSiteMenuItem';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  productId: Scalars['ID'];
};

export type ArchiveMachineChannelInput = {
  channel: Scalars['Int'];
  machineId: Scalars['ID'];
};

export type ArchiveStockRecordsInput = {
  channel: Scalars['Int'];
  machineId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type ChannelInfo = {
  __typename?: 'channelInfo';
  balance: Scalars['Int'];
  channel: Scalars['Int'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
};

export type CreateUserInput = {
  password?: InputMaybe<Scalars['String']>;
  realName: Scalars['String'];
  userEmail?: InputMaybe<Scalars['String']>;
  userName: Scalars['String'];
  userType: UserType;
};

export type MenuIdByMachineChannel = {
  channel: Scalars['Int'];
  machineId: Scalars['ID'];
};

export type MenuIdByMachineProduct = {
  machineId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type MultiLog = {
  __typename?: 'multiLog';
  apiToken?: Maybe<Scalars['String']>;
  clientToken?: Maybe<Scalars['String']>;
  gqlToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logDate: Scalars['String'];
  logLevel: Scalars['Int'];
  logPath?: Maybe<Scalars['String']>;
  logText?: Maybe<Scalars['String']>;
  machineId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type StockIdFromMachineChannel = {
  channel: Scalars['Int'];
  machineId: Scalars['ID'];
};

export type StockTransactionV2 = {
  __typename?: 'stockTransactionV2';
  archived?: Maybe<Scalars['Int']>;
  balance: Scalars['Int'];
  channel: Scalars['Int'];
  id: Scalars['ID'];
  machineId: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  ref?: Maybe<Scalars['String']>;
  transactionTimestamp: Scalars['DateTime'];
  transactionType: TransactionType;
  who?: Maybe<Scalars['ID']>;
};

export type StockTransactionV2machineInventory = {
  __typename?: 'stockTransactionV2machineInventory';
  channelInfo: Array<ChannelInfo>;
  machine: Machine;
  machineId: Scalars['ID'];
};

export enum TransactionType {
  Diff = 'DIFF',
  Inventory = 'INVENTORY',
  Movein = 'MOVEIN',
  Moveout = 'MOVEOUT',
  Order = 'ORDER',
  Resupply = 'RESUPPLY',
  Spoil = 'SPOIL'
}

export type UpdateEverythingLine = {
  archived: Scalars['Int'];
  channel: Scalars['Int'];
  driverId: Scalars['String'];
  machineId: Scalars['String'];
  movein: Scalars['Int'];
  moveout: Scalars['Int'];
  newBalance: Scalars['Int'];
  productId: Scalars['String'];
  ref: Scalars['String'];
  resupply: Scalars['Int'];
  resupplyDirty: Scalars['Boolean'];
  spoil: Scalars['Int'];
  spoilDirty: Scalars['Boolean'];
};

export type UpdateUserInput = {
  id: Scalars['ID'];
  password?: InputMaybe<Scalars['String']>;
  realName?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
};

export type User = {
  __typename?: 'user';
  id: Scalars['ID'];
  password?: Maybe<Scalars['String']>;
  realName: Scalars['String'];
  userEmail?: Maybe<Scalars['String']>;
  userName: Scalars['String'];
  userType: UserType;
};

export enum UserType {
  Admin = 'ADMIN',
  Backoffice = 'BACKOFFICE',
  Driver = 'DRIVER'
}

export type CampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, description: string, startDate?: string | null, endDate?: string | null, discountId?: string | null, autoDiscount?: boolean | null, discountType?: string | null, discountValue?: number | null, discount?: { __typename?: 'Discount', id: string, code: string } | null }> };

export type RefetchCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type RefetchCampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, description: string }> };

export type CampaignActivitiesByCampaignQueryVariables = Exact<{
  input: CampaignActivitiesInput;
}>;


export type CampaignActivitiesByCampaignQuery = { __typename?: 'Query', campaignActivitiesByCampaign: Array<{ __typename?: 'CampaignActivity', id: string, campaignId?: string | null, customerId?: string | null, discountId?: string | null, machineId?: string | null, productId?: string | null, sendDate?: string | null, createdAt: string, updatedAt?: string | null }> };

export type AddNewCampaignMutationVariables = Exact<{
  input: AddNewCampaignInput;
}>;


export type AddNewCampaignMutation = { __typename?: 'Mutation', addNewCampaign: { __typename?: 'Campaign', id: string } };

export type ConsentedCustomersQueryVariables = Exact<{
  input?: InputMaybe<ConsentedCustomersInput>;
}>;


export type ConsentedCustomersQuery = { __typename?: 'Query', consentedCustomers: Array<{ __typename?: 'Customer', id: string, phoneNumber?: string | null, email?: string | null, marketingConsent: boolean, consentedToMarketingAt?: any | null, consentPhone?: boolean | null, consentPhoneAt?: any | null, consentEmail?: boolean | null, consentEmailAt?: any | null, createdAt?: any | null, loyaltySignup?: boolean | null, loyaltySignupAt?: any | null, loyaltyPurchases?: number | null }> };

export type ConsentedCustomersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsentedCustomersCountQuery = { __typename?: 'Query', consentedCustomersCount?: number | null };

export type DiscountsQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type DiscountsQuery = { __typename?: 'Query', discounts: Array<{ __typename?: 'Discount', id: string, code: string, type: DiscountType, reduction: number, singleUse: boolean, active: boolean, validFrom: any, validTo: any, validMachineIds: Array<string> }> };

export type BatchCreateDiscountsMutationVariables = Exact<{
  input: BatchCreateDiscountsInput;
}>;


export type BatchCreateDiscountsMutation = { __typename?: 'Mutation', batchCreateDiscounts: Array<{ __typename?: 'Discount', code: string }> };

export type UpdateDiscountMutationVariables = Exact<{
  input: UpdateDiscountInput;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount: { __typename?: 'Discount', id: string } };

export type CreateDiscountMutationVariables = Exact<{
  input: CreateDiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount: { __typename?: 'Discount', id: string } };

export type ErrorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ErrorsQuery = { __typename?: 'Query', errors: Array<{ __typename?: 'Error', id: string, date: any, statusCode: string, metadata?: { __typename?: 'ErrorMetadata', requestedChannel?: number | null } | null, machine: { __typename?: 'Machine', id: string, location: string } }> };

export type SetManyChannelStockMutationVariables = Exact<{
  input: SetManyChannelStockInput;
}>;


export type SetManyChannelStockMutation = { __typename?: 'Mutation', setManyChannelStock?: Array<Array<number | null> | null> | null };

export type MachineByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MachineByIdQuery = { __typename?: 'Query', machineById: { __typename?: 'Machine', channels: Array<number>, menuItems: Array<{ __typename?: 'MenuItem', id: string, availableTo?: any | null, availableFrom?: any | null, product: { __typename?: 'Product', id: string, category: Category, texts: Array<{ __typename?: 'ProductText', name?: string | null, locale: Locale }> }, stocks: Array<{ __typename?: 'Stock', id: string, channel: number, quantity: number, menuItem: { __typename?: 'MenuItem', id: string, product: { __typename?: 'Product', id: string, texts: Array<{ __typename?: 'ProductText', name?: string | null, locale: Locale }> } } }> }> } };

export type HasMachineHadRefillTodayQueryVariables = Exact<{
  machineId: Scalars['ID'];
}>;


export type HasMachineHadRefillTodayQuery = { __typename?: 'Query', hasMachineHadRefillToday: boolean };

export type MachineById_MachineInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MachineById_MachineInfoQuery = { __typename?: 'Query', machineById: { __typename?: 'Machine', id: string, location: string, pointOfServiceId?: string | null, active: boolean, paymentMethods: Array<PaymentMethod>, channels: Array<number>, launchDate?: any | null, isfridge?: number | null, twentyfourHours?: boolean | null, machineType?: string | null, machineLocationId?: string | null, cardTerminal?: { __typename?: 'CardTerminal', name: string } | null, productCapacities: Array<{ __typename?: 'ProductCapacity', id: number, productId: string, capacity: number, product?: { __typename?: 'Product', id: string, texts: Array<{ __typename?: 'ProductText', name?: string | null, locale: Locale }> } | null }>, machineConfigs: Array<{ __typename?: 'MachineConfig', id: string, key: ConfigKey, value: string }> } };

export type AddChannelMutationVariables = Exact<{
  input: ChannelInput;
}>;


export type AddChannelMutation = { __typename?: 'Mutation', addChannel?: { __typename?: 'Machine', id: string } | null };

export type DeleteChannelMutationVariables = Exact<{
  input: ChannelInput;
}>;


export type DeleteChannelMutation = { __typename?: 'Mutation', deleteChannel?: { __typename?: 'Machine', id: string } | null };

export type AddPaymentMethodMutationVariables = Exact<{
  input: PaymentMethodInput;
}>;


export type AddPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethod?: { __typename?: 'Machine', id: string } | null };

export type RemovePaymentMethodMutationVariables = Exact<{
  input: PaymentMethodInput;
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod?: { __typename?: 'Machine', id: string } | null };

export type SetFridgeMutationVariables = Exact<{
  input: SetFridgeInput;
}>;


export type SetFridgeMutation = { __typename?: 'Mutation', setFridge?: { __typename?: 'Machine', id: string } | null };

export type SetActiveMutationVariables = Exact<{
  input: SetActiveInput;
}>;


export type SetActiveMutation = { __typename?: 'Mutation', setActive?: { __typename?: 'Machine', id: string } | null };

export type SetLocationMutationVariables = Exact<{
  input: SetLocationInput;
}>;


export type SetLocationMutation = { __typename?: 'Mutation', setLocation?: { __typename?: 'Machine', id: string } | null };

export type SetMachineLocationMutationVariables = Exact<{
  input: SetMachineLocationInput;
}>;


export type SetMachineLocationMutation = { __typename?: 'Mutation', setMachineLocation?: { __typename?: 'Machine', id: string } | null };

export type CopyMachineConfigMutationVariables = Exact<{
  input: CopyMachineConfigInput;
}>;


export type CopyMachineConfigMutation = { __typename?: 'Mutation', copyMachineConfig?: { __typename?: 'Machine', id: string } | null };

export type CardTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type CardTerminalsQuery = { __typename?: 'Query', cardTerminals: Array<{ __typename?: 'CardTerminal', id: string, name: string, machine?: { __typename?: 'Machine', id: string } | null }> };

export type SetMachineCardTerminalMutationVariables = Exact<{
  input: SetMachineCardTerminalInput;
}>;


export type SetMachineCardTerminalMutation = { __typename?: 'Mutation', setMachineCardTerminal?: { __typename?: 'Machine', id: string } | null };

export type AddProductCapacityMutationVariables = Exact<{
  input: AddProductCapacityInput;
}>;


export type AddProductCapacityMutation = { __typename?: 'Mutation', addProductCapacity?: { __typename?: 'ProductCapacity', id: number } | null };

export type RemoveProductCapacityMutationVariables = Exact<{
  input: RemoveProductCapacityInput;
}>;


export type RemoveProductCapacityMutation = { __typename?: 'Mutation', removeProductCapacity?: boolean | null };

export type DeleteMenuItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMenuItemMutation = { __typename?: 'Mutation', deleteMenuItem: { __typename?: 'MenuItem', id: string } };

export type UpdateMenuItemMutationVariables = Exact<{
  input: UpdateMenuItemInput;
}>;


export type UpdateMenuItemMutation = { __typename?: 'Mutation', updateMenuItem: { __typename?: 'MenuItem', id: string } };

export type MenuItemsByMachineIdQueryVariables = Exact<{
  input: MenuItemsByMachineIdInput;
}>;


export type MenuItemsByMachineIdQuery = { __typename?: 'Query', menuItemsByMachineId: Array<{ __typename?: 'MenuItem', id: string, overridePrice?: number | null, availableFrom?: any | null, availableTo?: any | null, product: { __typename?: 'Product', id: string, category: Category, images: Array<{ __typename?: 'Image', imageType: ImageType, imageUrl: string }>, texts: Array<{ __typename?: 'ProductText', name?: string | null, locale: Locale }> }, stocks: Array<{ __typename?: 'Stock', channel: number }> }> };

export type ProductsQueryVariables = Exact<{
  activeOnly: Scalars['Boolean'];
}>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, texts: Array<{ __typename?: 'ProductText', name?: string | null, locale: Locale }> }> };

export type CreateMenuItemMutationVariables = Exact<{
  input: CreateMenuItemInput;
}>;


export type CreateMenuItemMutation = { __typename?: 'Mutation', createMenuItem: { __typename?: 'MenuItem', id: string } };

export type Products_TextsQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type Products_TextsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, texts: Array<{ __typename?: 'ProductText', locale: Locale, name?: string | null }> }> };

export type FilteredOrdersQueryVariables = Exact<{
  filters?: InputMaybe<OrderFilters>;
}>;


export type FilteredOrdersQuery = { __typename?: 'Query', filteredOrders: Array<{ __typename?: 'Order', id: string, status: OrderStatus, totalPrice: number, totalReduction: number, orderDate: any, orderItems: Array<{ __typename?: 'OrderItem', product: { __typename?: 'Product', id: string, texts: Array<{ __typename?: 'ProductText', name?: string | null, locale: Locale }> } }>, payment?: { __typename?: 'Payment', id: string, method: PaymentMethod, refunds: Array<{ __typename?: 'Refund', amount: number }> } | null, discount?: { __typename?: 'Discount', code: string } | null, machine: { __typename?: 'Machine', id: string, location: string }, customer?: { __typename?: 'Customer', id: string, phoneNumber?: string | null, email?: string | null } | null }> };

export type OrderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderByIdQuery = { __typename?: 'Query', orderById: { __typename?: 'Order', orderDate: any, id: string, status: OrderStatus, totalPrice: number, totalReduction: number, orderItems: Array<{ __typename?: 'OrderItem', id: string, price: number, product: { __typename?: 'Product', id: string, texts: Array<{ __typename?: 'ProductText', name?: string | null, locale: Locale }> } }>, payment?: { __typename?: 'Payment', id: string, method: PaymentMethod, totalAmount: number, status: PaymentStatus, merchantData: { __typename?: 'CardData', type: PaymentMethod, sessionID: string, retailTransactionID?: string | null, fingerPrint?: string | null } | { __typename?: 'DatatransData' } | { __typename?: 'SwishData', type: PaymentMethod, id?: string | null, payerAlias?: string | null, error?: { __typename?: 'SwishError', errorCode: string, additionalInformation?: string | null } | null }, cardCaptures: Array<{ __typename?: 'CardCapture', id: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, createdAt?: any | null }> } | null, discount?: { __typename?: 'Discount', id: string, code: string, type: DiscountType, reduction: number } | null, machine: { __typename?: 'Machine', id: string, location: string }, customer?: { __typename?: 'Customer', id: string, phoneNumber?: string | null, email?: string | null } | null } };

export type RefundAmountMutationVariables = Exact<{
  input: RefundAmountInput;
}>;


export type RefundAmountMutation = { __typename?: 'Mutation', refundAmount: { __typename?: 'Refund', id: string } };

export type SendReceiptMutationVariables = Exact<{
  input: SendReceiptInput;
}>;


export type SendReceiptMutation = { __typename?: 'Mutation', sendReceipt?: boolean | null };

export type LabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type LabelsQuery = { __typename?: 'Query', labels: Array<{ __typename?: 'Label', id: string, labelType: LabelType }> };

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductByIdQuery = { __typename?: 'Query', productById: { __typename?: 'Product', id: string, price: number, category: Category, origin: ProductOrigin, active: boolean, shelfLife?: number | null, dishTemperature?: DishTemperature | null, procurementPrice?: number | null, collaborationItem?: boolean | null, collaborationOrigin?: string | null, images: Array<{ __typename?: 'Image', id: string, imageType: ImageType, imageUrl: string }>, labels: Array<{ __typename?: 'Label', id: string, labelType: LabelType }>, texts: Array<{ __typename?: 'ProductText', name?: string | null, description?: string | null, allergens?: string | null, nutritionalInformation?: string | null, instructions?: string | null, locale: Locale }> } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string } };

export type ActivateProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateProductMutation = { __typename?: 'Mutation', activateProduct: boolean };

export type DeactivateProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateProductMutation = { __typename?: 'Mutation', deactivateProduct: boolean };

export type AddNewProductMutationVariables = Exact<{
  input: AddNewProductInput;
}>;


export type AddNewProductMutation = { __typename?: 'Mutation', addNewProduct: { __typename?: 'Product', id: string } };

export type RefetchProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type RefetchProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string }> };

export type MachineLocationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MachineLocationByIdQuery = { __typename?: 'Query', machineLocationById: { __typename?: 'MachineLocation', id: string, locationName?: string | null, corporatehq?: boolean | null, locationSize?: number | null, isLocalPopulation?: boolean | null, clothingType?: number | null, outdoorCompetition?: number | null, directCompetitor?: number | null, customerType?: string | null, Canteen?: string | null, machinePosition?: string | null, homeOfficeDays?: number | null, locationCategoryId?: string | null, locationTypeId?: string | null, geographicalLocationId?: string | null, locationCategory?: { __typename?: 'LocationCategory', id: string, locationCategoryName?: string | null } | null, locationType?: { __typename?: 'LocationType', id: string, locationTypeName?: string | null } | null, geographicalLocation?: { __typename?: 'GeographicalLocation', id: string, geographicalLocationName?: string | null } | null } };

export type MachineLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MachineLocationsQuery = { __typename?: 'Query', machineLocations: Array<{ __typename?: 'MachineLocation', id: string, locationName?: string | null, corporatehq?: boolean | null, locationSize?: number | null, isLocalPopulation?: boolean | null, clothingType?: number | null, outdoorCompetition?: number | null, directCompetitor?: number | null, customerType?: string | null, Canteen?: string | null, machinePosition?: string | null, homeOfficeDays?: number | null, locationCategoryId?: string | null, locationTypeId?: string | null, geographicalLocationId?: string | null, locationCategory?: { __typename?: 'LocationCategory', id: string, locationCategoryName?: string | null } | null, locationType?: { __typename?: 'LocationType', id: string, locationTypeName?: string | null } | null, geographicalLocation?: { __typename?: 'GeographicalLocation', id: string, geographicalLocationName?: string | null } | null }> };

export type UpdateMachineLocationMutationVariables = Exact<{
  input: UpdateMachineLocationInput;
}>;


export type UpdateMachineLocationMutation = { __typename?: 'Mutation', updateMachineLocation?: { __typename?: 'MachineLocation', id: string, locationName?: string | null, corporatehq?: boolean | null, locationSize?: number | null, isLocalPopulation?: boolean | null, clothingType?: number | null, outdoorCompetition?: number | null, directCompetitor?: number | null, customerType?: string | null, Canteen?: string | null, machinePosition?: string | null, homeOfficeDays?: number | null, locationCategoryId?: string | null, locationTypeId?: string | null, geographicalLocationId?: string | null } | null };

export type AddNewMachineLocationMutationVariables = Exact<{
  input: AddNewMachineLocationInput;
}>;


export type AddNewMachineLocationMutation = { __typename?: 'Mutation', addNewMachineLocation?: { __typename?: 'MachineLocation', id: string, locationName?: string | null, corporatehq?: boolean | null, locationSize?: number | null, isLocalPopulation?: boolean | null, clothingType?: number | null, outdoorCompetition?: number | null, directCompetitor?: number | null, customerType?: string | null, Canteen?: string | null, machinePosition?: string | null, homeOfficeDays?: number | null, locationCategoryId?: string | null, locationTypeId?: string | null, geographicalLocationId?: string | null } | null };

export type RefetchMachineLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type RefetchMachineLocationsQuery = { __typename?: 'Query', machineLocations: Array<{ __typename?: 'MachineLocation', id: string, locationName?: string | null, corporatehq?: boolean | null, locationCategoryId?: string | null, locationTypeId?: string | null, geographicalLocationId?: string | null, locationCategory?: { __typename?: 'LocationCategory', id: string, locationCategoryName?: string | null } | null, locationType?: { __typename?: 'LocationType', id: string, locationTypeName?: string | null } | null, geographicalLocation?: { __typename?: 'GeographicalLocation', id: string, geographicalLocationName?: string | null } | null }> };

export type LocationCategoryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationCategoryByIdQuery = { __typename?: 'Query', locationCategoryById: { __typename?: 'LocationCategory', id: string, locationCategoryName?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type LocationCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationCategoriesQuery = { __typename?: 'Query', locationCategories: Array<{ __typename?: 'LocationCategory', id: string, locationCategoryName?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type UpdateLocationCategoryMutationVariables = Exact<{
  input: UpdateLocationCategoryInput;
}>;


export type UpdateLocationCategoryMutation = { __typename?: 'Mutation', updateLocationCategory?: { __typename?: 'LocationCategory', id: string } | null };

export type AddNewLocationCategoryMutationVariables = Exact<{
  input: AddNewLocationCategoryInput;
}>;


export type AddNewLocationCategoryMutation = { __typename?: 'Mutation', addNewLocationCategory?: { __typename?: 'LocationCategory', id: string } | null };

export type RefetchLocationCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RefetchLocationCategoriesQuery = { __typename?: 'Query', locationCategories: Array<{ __typename?: 'LocationCategory', id: string, locationCategoryName?: string | null }> };

export type LocationTypeByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationTypeByIdQuery = { __typename?: 'Query', locationTypeById: { __typename?: 'LocationType', id: string, locationTypeName?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type LocationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationTypesQuery = { __typename?: 'Query', locationTypes: Array<{ __typename?: 'LocationType', id: string, locationTypeName?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type UpdateLocationTypeMutationVariables = Exact<{
  input: UpdateLocationTypeInput;
}>;


export type UpdateLocationTypeMutation = { __typename?: 'Mutation', updateLocationType?: { __typename?: 'LocationType', id: string } | null };

export type AddNewLocationTypeMutationVariables = Exact<{
  input: AddNewLocationTypeInput;
}>;


export type AddNewLocationTypeMutation = { __typename?: 'Mutation', addNewLocationType?: { __typename?: 'LocationType', id: string } | null };

export type RefetchLocationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type RefetchLocationTypesQuery = { __typename?: 'Query', locationTypes: Array<{ __typename?: 'LocationType', id: string, locationTypeName?: string | null }> };

export type GeographicalLocationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GeographicalLocationByIdQuery = { __typename?: 'Query', geographicalLocationById: { __typename?: 'GeographicalLocation', id: string, geographicalLocationName?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type GeographicalLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GeographicalLocationsQuery = { __typename?: 'Query', geographicalLocations: Array<{ __typename?: 'GeographicalLocation', id: string, geographicalLocationName?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type UpdateGeographicalLocationMutationVariables = Exact<{
  input: UpdateGeographicalLocationInput;
}>;


export type UpdateGeographicalLocationMutation = { __typename?: 'Mutation', updateGeographicalLocation?: { __typename?: 'GeographicalLocation', id: string } | null };

export type AddNewGeographicalLocationMutationVariables = Exact<{
  input: AddNewGeographicalLocationInput;
}>;


export type AddNewGeographicalLocationMutation = { __typename?: 'Mutation', addNewGeographicalLocation?: { __typename?: 'GeographicalLocation', id: string } | null };

export type RefetchGeographicalLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type RefetchGeographicalLocationsQuery = { __typename?: 'Query', geographicalLocations: Array<{ __typename?: 'GeographicalLocation', id: string, geographicalLocationName?: string | null }> };

export type MachinesQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type MachinesQuery = { __typename?: 'Query', machines: Array<{ __typename?: 'Machine', id: string, location: string, active: boolean, isfridge?: number | null, isOpen?: boolean | null, lastPing?: any | null }> };


export const CampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"discountId"}},{"kind":"Field","name":{"kind":"Name","value":"autoDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignsQuery, CampaignsQueryVariables>;
export const RefetchCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefetchCampaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<RefetchCampaignsQuery, RefetchCampaignsQueryVariables>;
export const CampaignActivitiesByCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CampaignActivitiesByCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignActivitiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignActivitiesByCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"discountId"}},{"kind":"Field","name":{"kind":"Name","value":"machineId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CampaignActivitiesByCampaignQuery, CampaignActivitiesByCampaignQueryVariables>;
export const AddNewCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNewCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddNewCampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNewCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddNewCampaignMutation, AddNewCampaignMutationVariables>;
export const ConsentedCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsentedCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentedCustomersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentedCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"marketingConsent"}},{"kind":"Field","name":{"kind":"Name","value":"consentedToMarketingAt"}},{"kind":"Field","name":{"kind":"Name","value":"consentPhone"}},{"kind":"Field","name":{"kind":"Name","value":"consentPhoneAt"}},{"kind":"Field","name":{"kind":"Name","value":"consentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"consentEmailAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltySignup"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltySignupAt"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyPurchases"}}]}}]}}]} as unknown as DocumentNode<ConsentedCustomersQuery, ConsentedCustomersQueryVariables>;
export const ConsentedCustomersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsentedCustomersCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentedCustomersCount"}}]}}]} as unknown as DocumentNode<ConsentedCustomersCountQuery, ConsentedCustomersCountQueryVariables>;
export const DiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Discounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"reduction"}},{"kind":"Field","name":{"kind":"Name","value":"singleUse"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"validMachineIds"}}]}}]}}]} as unknown as DocumentNode<DiscountsQuery, DiscountsQueryVariables>;
export const BatchCreateDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BatchCreateDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchCreateDiscountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchCreateDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BatchCreateDiscountsMutation, BatchCreateDiscountsMutationVariables>;
export const UpdateDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDiscountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const CreateDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDiscountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const ErrorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestedChannel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"machine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<ErrorsQuery, ErrorsQueryVariables>;
export const SetManyChannelStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetManyChannelStock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetManyChannelStockInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setManyChannelStock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SetManyChannelStockMutation, SetManyChannelStockMutationVariables>;
export const MachineByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MachineById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"machineById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"menuItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableTo"}},{"kind":"Field","name":{"kind":"Name","value":"availableFrom"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"menuItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MachineByIdQuery, MachineByIdQueryVariables>;
export const HasMachineHadRefillTodayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasMachineHadRefillToday"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"machineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMachineHadRefillToday"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"machineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"machineId"}}}]}]}}]} as unknown as DocumentNode<HasMachineHadRefillTodayQuery, HasMachineHadRefillTodayQueryVariables>;
export const MachineById_MachineInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MachineById_MachineInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"machineById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfServiceId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"launchDate"}},{"kind":"Field","name":{"kind":"Name","value":"cardTerminal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isfridge"}},{"kind":"Field","name":{"kind":"Name","value":"twentyfourHours"}},{"kind":"Field","name":{"kind":"Name","value":"machineType"}},{"kind":"Field","name":{"kind":"Name","value":"machineLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"productCapacities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"machineConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<MachineById_MachineInfoQuery, MachineById_MachineInfoQueryVariables>;
export const AddChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddChannelMutation, AddChannelMutationVariables>;
export const DeleteChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteChannelMutation, DeleteChannelMutationVariables>;
export const AddPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const RemovePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const SetFridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetFridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetFridgeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setFridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetFridgeMutation, SetFridgeMutationVariables>;
export const SetActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetActiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetActiveMutation, SetActiveMutationVariables>;
export const SetLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetLocationMutation, SetLocationMutationVariables>;
export const SetMachineLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMachineLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetMachineLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setMachineLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetMachineLocationMutation, SetMachineLocationMutationVariables>;
export const CopyMachineConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CopyMachineConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CopyMachineConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyMachineConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CopyMachineConfigMutation, CopyMachineConfigMutationVariables>;
export const CardTerminalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardTerminals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardTerminals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"machine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CardTerminalsQuery, CardTerminalsQueryVariables>;
export const SetMachineCardTerminalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMachineCardTerminal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetMachineCardTerminalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setMachineCardTerminal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetMachineCardTerminalMutation, SetMachineCardTerminalMutationVariables>;
export const AddProductCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProductCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddProductCapacityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProductCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddProductCapacityMutation, AddProductCapacityMutationVariables>;
export const RemoveProductCapacityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProductCapacity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveProductCapacityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProductCapacity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RemoveProductCapacityMutation, RemoveProductCapacityMutationVariables>;
export const DeleteMenuItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMenuItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMenuItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMenuItemMutation, DeleteMenuItemMutationVariables>;
export const UpdateMenuItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMenuItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMenuItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMenuItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>;
export const MenuItemsByMachineIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MenuItemsByMachineId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MenuItemsByMachineIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuItemsByMachineId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageType"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overridePrice"}},{"kind":"Field","name":{"kind":"Name","value":"availableFrom"}},{"kind":"Field","name":{"kind":"Name","value":"availableTo"}},{"kind":"Field","name":{"kind":"Name","value":"stocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}}]}}]}}]}}]} as unknown as DocumentNode<MenuItemsByMachineIdQuery, MenuItemsByMachineIdQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const CreateMenuItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMenuItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMenuItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMenuItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMenuItemMutation, CreateMenuItemMutationVariables>;
export const Products_TextsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products_Texts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Products_TextsQuery, Products_TextsQueryVariables>;
export const FilteredOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilteredOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalReduction"}},{"kind":"Field","name":{"kind":"Name","value":"orderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"machine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderDate"}}]}}]}}]} as unknown as DocumentNode<FilteredOrdersQuery, FilteredOrdersQueryVariables>;
export const OrderByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalReduction"}},{"kind":"Field","name":{"kind":"Name","value":"orderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"merchantData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwishData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payerAlias"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"additionalInformation"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sessionID"}},{"kind":"Field","name":{"kind":"Name","value":"retailTransactionID"}},{"kind":"Field","name":{"kind":"Name","value":"fingerPrint"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardCaptures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"reduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"machine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<OrderByIdQuery, OrderByIdQueryVariables>;
export const RefundAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefundAmount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundAmountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refundAmount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RefundAmountMutation, RefundAmountMutationVariables>;
export const SendReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendReceiptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendReceiptMutation, SendReceiptMutationVariables>;
export const LabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelType"}}]}}]}}]} as unknown as DocumentNode<LabelsQuery, LabelsQueryVariables>;
export const ProductByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageType"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"allergens"}},{"kind":"Field","name":{"kind":"Name","value":"nutritionalInformation"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"shelfLife"}},{"kind":"Field","name":{"kind":"Name","value":"dishTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"procurementPrice"}},{"kind":"Field","name":{"kind":"Name","value":"collaborationItem"}},{"kind":"Field","name":{"kind":"Name","value":"collaborationOrigin"}}]}}]}}]} as unknown as DocumentNode<ProductByIdQuery, ProductByIdQueryVariables>;
export const UpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;
export const ActivateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ActivateProductMutation, ActivateProductMutationVariables>;
export const DeactivateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeactivateProductMutation, DeactivateProductMutationVariables>;
export const AddNewProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNewProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddNewProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNewProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddNewProductMutation, AddNewProductMutationVariables>;
export const RefetchProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefetchProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RefetchProductsQuery, RefetchProductsQueryVariables>;
export const MachineLocationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MachineLocationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"machineLocationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"corporatehq"}},{"kind":"Field","name":{"kind":"Name","value":"locationSize"}},{"kind":"Field","name":{"kind":"Name","value":"isLocalPopulation"}},{"kind":"Field","name":{"kind":"Name","value":"clothingType"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"directCompetitor"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"Canteen"}},{"kind":"Field","name":{"kind":"Name","value":"machinePosition"}},{"kind":"Field","name":{"kind":"Name","value":"homeOfficeDays"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationName"}}]}}]}}]}}]} as unknown as DocumentNode<MachineLocationByIdQuery, MachineLocationByIdQueryVariables>;
export const MachineLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MachineLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"machineLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"corporatehq"}},{"kind":"Field","name":{"kind":"Name","value":"locationSize"}},{"kind":"Field","name":{"kind":"Name","value":"isLocalPopulation"}},{"kind":"Field","name":{"kind":"Name","value":"clothingType"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"directCompetitor"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"Canteen"}},{"kind":"Field","name":{"kind":"Name","value":"machinePosition"}},{"kind":"Field","name":{"kind":"Name","value":"homeOfficeDays"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationName"}}]}}]}}]}}]} as unknown as DocumentNode<MachineLocationsQuery, MachineLocationsQueryVariables>;
export const UpdateMachineLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMachineLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMachineLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMachineLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"corporatehq"}},{"kind":"Field","name":{"kind":"Name","value":"locationSize"}},{"kind":"Field","name":{"kind":"Name","value":"isLocalPopulation"}},{"kind":"Field","name":{"kind":"Name","value":"clothingType"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"directCompetitor"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"Canteen"}},{"kind":"Field","name":{"kind":"Name","value":"machinePosition"}},{"kind":"Field","name":{"kind":"Name","value":"homeOfficeDays"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationId"}}]}}]}}]} as unknown as DocumentNode<UpdateMachineLocationMutation, UpdateMachineLocationMutationVariables>;
export const AddNewMachineLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNewMachineLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddNewMachineLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNewMachineLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"corporatehq"}},{"kind":"Field","name":{"kind":"Name","value":"locationSize"}},{"kind":"Field","name":{"kind":"Name","value":"isLocalPopulation"}},{"kind":"Field","name":{"kind":"Name","value":"clothingType"}},{"kind":"Field","name":{"kind":"Name","value":"outdoorCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"directCompetitor"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"Canteen"}},{"kind":"Field","name":{"kind":"Name","value":"machinePosition"}},{"kind":"Field","name":{"kind":"Name","value":"homeOfficeDays"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationId"}}]}}]}}]} as unknown as DocumentNode<AddNewMachineLocationMutation, AddNewMachineLocationMutationVariables>;
export const RefetchMachineLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefetchMachineLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"machineLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"corporatehq"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationName"}}]}}]}}]}}]} as unknown as DocumentNode<RefetchMachineLocationsQuery, RefetchMachineLocationsQueryVariables>;
export const LocationCategoryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationCategoryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCategoryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<LocationCategoryByIdQuery, LocationCategoryByIdQueryVariables>;
export const LocationCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<LocationCategoriesQuery, LocationCategoriesQueryVariables>;
export const UpdateLocationCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocationCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLocationCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocationCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationCategoryMutation, UpdateLocationCategoryMutationVariables>;
export const AddNewLocationCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNewLocationCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddNewLocationCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNewLocationCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddNewLocationCategoryMutation, AddNewLocationCategoryMutationVariables>;
export const RefetchLocationCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefetchLocationCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationCategoryName"}}]}}]}}]} as unknown as DocumentNode<RefetchLocationCategoriesQuery, RefetchLocationCategoriesQueryVariables>;
export const LocationTypeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationTypeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<LocationTypeByIdQuery, LocationTypeByIdQueryVariables>;
export const LocationTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<LocationTypesQuery, LocationTypesQueryVariables>;
export const UpdateLocationTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocationType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLocationTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationTypeMutation, UpdateLocationTypeMutationVariables>;
export const AddNewLocationTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNewLocationType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddNewLocationTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNewLocationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddNewLocationTypeMutation, AddNewLocationTypeMutationVariables>;
export const RefetchLocationTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefetchLocationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationTypeName"}}]}}]}}]} as unknown as DocumentNode<RefetchLocationTypesQuery, RefetchLocationTypesQueryVariables>;
export const GeographicalLocationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeographicalLocationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GeographicalLocationByIdQuery, GeographicalLocationByIdQueryVariables>;
export const GeographicalLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeographicalLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographicalLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GeographicalLocationsQuery, GeographicalLocationsQueryVariables>;
export const UpdateGeographicalLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGeographicalLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGeographicalLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGeographicalLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateGeographicalLocationMutation, UpdateGeographicalLocationMutationVariables>;
export const AddNewGeographicalLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNewGeographicalLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddNewGeographicalLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNewGeographicalLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddNewGeographicalLocationMutation, AddNewGeographicalLocationMutationVariables>;
export const RefetchGeographicalLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefetchGeographicalLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographicalLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalLocationName"}}]}}]}}]} as unknown as DocumentNode<RefetchGeographicalLocationsQuery, RefetchGeographicalLocationsQueryVariables>;
export const MachinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Machines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"machines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"isfridge"}},{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"lastPing"}}]}}]}}]} as unknown as DocumentNode<MachinesQuery, MachinesQueryVariables>;